export const rampRateToSeconds=[0,4000,8000,12000,20000,30000,40000,60000,90000,120000,180000,300000,420000,600000,900000,1020000]